import { DefaultLightTheme, DefaultDarkTheme } from '@cb/solaris-react/Constants/Theme';
import Store from '@cb/solaris-react/Utility/Store';
const THEME_IS_DARK_PERSIST_KEY = 'darkTheme';
export var BinaryTheme;
(function (BinaryTheme) {
    BinaryTheme[BinaryTheme["LIGHT"] = 0] = "LIGHT";
    BinaryTheme[BinaryTheme["DARK"] = 1] = "DARK";
})(BinaryTheme || (BinaryTheme = {}));
export default class ThemeStore extends Store {
    persistenceStore;
    constructor(persistenceStore) {
        super({
            // theme: null,
            type: null,
            isLoading: false,
        });
        this.persistenceStore = persistenceStore;
        this.on('type', async (type) => {
            await this.persistenceStore.setItem(THEME_IS_DARK_PERSIST_KEY, type === BinaryTheme.DARK);
        });
    }
    async loadThemeUsingPreferences(fallbackThemeIfNoPreference) {
        const preferenceIsDark = await this.persistenceStore.getItem(THEME_IS_DARK_PERSIST_KEY);
        if (preferenceIsDark === true) {
            this.setState('type', BinaryTheme.DARK);
        }
        else if (preferenceIsDark === false) {
            this.setState('type', BinaryTheme.LIGHT);
        }
        else {
            // No preference has been made, so respect the browser's defaults
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                this.setState('type', BinaryTheme.DARK);
            }
            else {
                this.setState('type', fallbackThemeIfNoPreference);
            }
        }
        this.setState('isLoading', false);
    }
    toggleTheme() {
        const type = this.getState('type');
        if (type == BinaryTheme.LIGHT) {
            this.setState('type', BinaryTheme.DARK);
        }
        else if (type == BinaryTheme.DARK) {
            this.setState('type', BinaryTheme.LIGHT);
        }
        else {
            throw Error('Theme does not appear to be loaded.');
        }
    }
    get theme() {
        const type = this.getState('type');
        if (type == BinaryTheme.LIGHT) {
            return DefaultLightTheme;
        }
        else if (type == BinaryTheme.DARK) {
            return DefaultDarkTheme;
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=ThemeStore.js.map